import requestModule from '@/assets/libs/requestModule'

const getDefinitions = async function () {
  let definitions = await requestModule.postRequest('project/info', {}, null, 'get')
  definitions = definitions.data[0] || definitions.data
  return definitions
}

const hexToRgba = (hex, alpha = 1) => {
  // Remove o # se existir
  hex = hex.replace(/^#/, '')

  // Converte #abc para #aabbcc
  if (hex.length === 3) {
    hex = hex.split('').map(c => c + c).join('')
  }

  const bigint = parseInt(hex, 16)
  const r = (bigint >> 16) & 255
  const g = (bigint >> 8) & 255
  const b = bigint & 255

  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

export {
  getDefinitions, hexToRgba
}
